<script setup lang="ts">
import GaiaButton from '../base/GaiaButton.vue';
import GaiaText from '../base/GaiaText.vue';
import { gaiaStatus } from '../themes/tokens';

const props = defineProps({
  confirmLabel: {
    type: String,
    default: 'Remove',
  },
  cancelLabel: {
    type: String,
    default: 'Cancel',
  },
});

const emit = defineEmits<{ confirm: []; cancel: [] }>();

const surface = gaiaStatus.alertSurface;
const border = gaiaStatus.alertBorder;
</script>

<template>
  <!-- Compact destructive confirm card from the Contract Detail panel
       (unlink matter / remove access) — the card-shaped sibling of
       GaiaTableRowState's confirm strip. -->
  <n-flex vertical :size="9" class="gaia-confirm-card">
    <gaia-text size="dense" tone="text" :style="{ lineHeight: 1.5 }"><slot /></gaia-text>
    <n-flex :size="8" :wrap="false">
      <gaia-button size="small" @click="emit('cancel')">{{ props.cancelLabel }}</gaia-button>
      <gaia-button size="small" type="error" @click="emit('confirm')">
        {{ props.confirmLabel }}
      </gaia-button>
    </n-flex>
  </n-flex>
</template>

<style scoped>
.gaia-confirm-card {
  padding: 11px 12px;
  border: 1px solid v-bind(border);
  border-radius: 10px;
  background: v-bind(surface);
}
</style>
